// ** Type Import
import type { OwnerStateThemeType } from '.';

const Tooltip = () => {
  return {
    MuiTooltip: {
      defaultProps: {
        arrow: true,
        enterDelay: 1000,
        enterNextDelay: 200,
      },
      styleOverrides: {
        tooltip: ({ theme }: OwnerStateThemeType) => ({
          backgroundColor: theme.palette.customColors.trackBg,
          boxShadow: theme.shadows[7],
          textAlign: 'center',
        }),
        arrow: ({ theme }: OwnerStateThemeType) => ({
          color: theme.palette.customColors.trackBg,
        }),
      },
    },
  };
};

export default Tooltip;
